var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { hide } from '../../util/show';
window.up.on(document, 'click', '.js-dismiss_three_members_hint_button', (event, element) => __awaiter(void 0, void 0, void 0, function* () {
    event.preventDefault();
    event.stopPropagation();
    const url = element.href;
    const headers = { 'x-csrf-token': element.dataset.csrfToken || '' };
    const options = { headers, method: 'delete' };
    const response = yield fetch(url, options);
    if (response.status >= 200 && response.status <= 400) {
        hide(document.querySelector('.members_count_hint-wrapper'));
    }
}));
window.up.compiler('.js-discover_campaign_color', (element) => {
    const color = element.dataset.campaignColor || null;
    document.documentElement.style.setProperty('--discover-campaign-color', color);
});
export const suggestionsInputSelector = '.js-project_search_suggestions_input';
const suggestionsSelector = '.js-project_search_suggestions';
const suggestionsCssClass = 'project_search__suggestions';
export const clearSuggestions = () => {
    const suggestions = document.querySelector(suggestionsSelector);
    if (suggestions) {
        suggestions.innerHTML = '';
        suggestions.classList.remove(suggestionsCssClass);
    }
};
window.up.compiler(suggestionsInputSelector, (input) => {
    const minSearchLength = JSON.parse(input.dataset.minSearchLength || '0');
    const watchOptions = { delay: 300 };
    window.up.watch(input, watchOptions, (value) => {
        if (value.trim().length >= minSearchLength) {
            const renderOptions = {
                url: input.dataset.suggestionsAction,
                method: 'post',
                params: { q: value.trim() },
                headers: { 'x-csrf-token': input.dataset.csrfToken },
                layer: window.up.layer.current,
                failTarget: suggestionsSelector
            };
            window.up.render(suggestionsSelector, renderOptions);
        }
        else {
            clearSuggestions();
        }
    });
});
